import React from "react";
import banner1 from "../../assets/images/contact.png";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../../assets/css/style.css"

const HowItWorks = () => {
    return (
        <div>
            <div class="banner-two banner-aggregators">
                <img src={banner1} alt="" />
            </div>
            <div class="banner-bottom">
                <div class="container-fluid">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 text-center banner-bottom-text">
                                <h4>How It Works </h4>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="howitworks-section ">
                <span class="v-line"></span>
                <div class="container-fluid">
                    <div class="container">
                        <div class="section-title pt-5 bg-fff z-99 po-r pb-5">
                            <h2 class="display-5"> How It Works</h2>
                        </div>

                        <div class="row">
                            <div class="col-md-6 col-sm-12 text-end">

                            </div>
                            <div class="col-md-6 col-sm-12 text-start">
                                <div class="howit-works-list">
                                    <i>1</i>
                                    <h4>Sign Up for Free</h4>
                                    <p>Create a university profile on GuideUni in minutes. Set your specific recruitment needs, preferences,
                                        and criteria to ensure you attract the right students.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 text-end">
                                <div class="howit-works-list">
                                    <i>2</i>
                                    <h4>Connect with Qualified Recruiters</h4>
                                    <p>Browse our extensive recruiter network and connect with partners who align with your objectives.
                                        GuideUni’s vetting process ensures that every recruiter meets high standards of integrity and
                                        efficiency.</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12 text-start">

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 text-end">

                            </div>
                            <div class="col-md-6 col-sm-12 text-start">
                                <div class="howit-works-list">
                                    <i>3</i>
                                    <h4>Manage Applications Seamlessly</h4>
                                    <p>Use GuideUni’s application dashboard to monitor, track, and manage applications from prospective
                                        students. Gain a comprehensive view of the admissions process at any stage.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 text-end">
                                <div class="howit-works-list">
                                    <i>4</i>
                                    <h4>Optimize Your Recruitment Strategy</h4>
                                    <p>Access real-time data and reports to refine and improve your international recruitment efforts. Make
                                        data-driven decisions and grow your institution’s global presence.</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12 text-start">

                            </div>
                        </div>
                        <div class="row">

                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="Education" role="tabpanel" aria-labelledby="Education-tab">
                                    <div>

                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowItWorks;